// The shared account pill supplies navigation on these pages.
export function topnavMode(_args: {
  readonly signedIn: boolean;
  readonly railPresent: boolean;
  readonly coworld: boolean;
}): "none" {
  return "none";
}
